import React from 'react'
import { createPortal } from 'react-dom'
import './PopUp.sass'

import Backdrop from '../Backdrop/Backdrop'
import SubmitFormButtons from '../SubmitFormButtons/SubmitFormButtons'
import Icon from '../Icon/Icon'

function PopUp(props) {
  if (!props.show) return null

  return createPortal(
    <Backdrop transparentBackDrop={props.transparentBackDrop} show={props.show} close={props.close}>
      <div className={['PopUp', ...(props.className ? [props.className] : [])].join(' ')}>
        <div className="PopUp-Header">
          <span>{props.title}</span>
          <Icon onClick={props.close} name="times" />
        </div>
        <div className="PopUp-Content">{props.children}</div>
        {props.submitButtons && (
          <SubmitFormButtons isLoading={props.isLoading} onSubmit={props.onSubmit} onCancel={props.close} />
        )}
        {props.customButtons && <div className="SubmitFormButtons">{props.customButtons}</div>}
      </div>
    </Backdrop>,
    document.body
  )
}

export default PopUp
